<template>
  <div class="classDetail container hasMenu">
    <div class="cdTop flexBw">
      <div class="clLeft">
        <!-- <img :src="classInfos.teacherAvatar" /> -->
        <img src="https://llss-file.langsounds.com/app/956dc1975353a8974aa74976f82b0ef6.png" />
        <span class="clSign" v-if="classInfos.isManager">管理员</span>
      </div>
      <div class="cdCenter flex-1">
        <div class="flex cdScl">
          <h3 class="school line1">{{ classInfos.school }}</h3>
          <span class="clSign" :class="classInfos.authStatus">{{
            classInfos.authStatusTxt
          }}</span>
          <div class="clSwitch flex-center" @click="status = true">
            <span class="iconfont qiehuan"></span>切换
          </div>
        </div>
        <div class="clTeach flex">
          {{ classInfos.gradeTxt }}
          <span class="iconfont denglurenxiang"></span>
          <p class="clPerson flex-center">
            <span class="clNum">{{ classInfos.studentCnt }}</span> 人
          </p>
        </div>
        <p class="teach">{{ classInfos.classesAdmin }}</p>
      </div>
      <div class="flex-v ">
        <div class="clBtn flex-center allDel back" @click="$emit('onBack')">
          <span class="iconfont fanhui1"></span> 返回班级
        </div>
        <div class="flex">
          <div class="clBtn flex-center" style="margin-right: 16px" @click="$emit('onCode', classesId)">
            <span class="iconfont xuesheng"></span> 邀请学生
          </div>
          <div class="clBtn flex-center" @click="$emit('onCode', classesId,true)">
            <span class="iconfont laoshi"></span> 邀请老师
          </div>
        </div>
      </div>

    </div>
    <div class="cdCenter flex">
      <ul class="cList flex">
        <li v-for="item in workMenus" :key="item.key">
          <h3>{{ workObj[item.key] || 0 }}</h3>
          <p>{{ item.text }}</p>
        </li>
      </ul>
      <div class="rankCount flex-v" @click="$refs.rankRef.openRank(classInfos)">
        <span class="iconfont paihang "></span>
        统计榜单
      </div>
    </div>
    <div class="cdBottom">
      <div class="flexBw">
        <div class="flex">
          <div class="clBtn flex-center" :class="menuKey == 'studentList' && 'on'" style="margin-right: 24px"
            @click="onTab('studentList')">
            <span class="iconfont xuesheng"></span> 学生列表
          </div>
          <div class="clBtn flex-center" :class="menuKey == 'teacherList' && 'on'" @click="onTab('teacherList')">
            <span class="iconfont laoshi"></span> 老师列表
          </div>
        </div>
        <template v-if="classInfos.isManager">
          <div class="clBtn flex-center allDel" v-show="!isLot && listObj[menuKey].length" @click="isLot = true">
            <span class="iconfont shanchu"></span> 批量移除
          </div>
          <div class="flex-center" v-show="isLot">
            <div class="clBtn lotBtn cancel flex-center" @click="onCancel">取消</div>
            <div class="clBtn lotBtn flex-center" @click="onAllSelect(false)">反选</div>
            <div class="clBtn lotBtn flex-center" @click="onAllSelect(true)">全选</div>
            <div class="clBtn flex-center" @click="onDel()">
              <span class="iconfont shanchu"></span> 确认移除
            </div>
          </div>
        </template>

      </div>
      <ul class="flex tdList">
        <li class="flex-center flex-v" v-for="item in listObj[menuKey]" :key="item.key">
          <div class="clDish iconfont clLot" :class="delList.includes(item.userId) ? 'xuanzhong' : 'weixuanzhong'"
            @click="onSelect(item.userId)" v-show="isLot && !item.isManager"></div>
          <div class="clDish" v-if="classInfos.isManager && !item.isManager" v-show="!isLot">
            <img src="https://llss-file.langsounds.com/picture/5884f964dad7833a7fec15bf76e50129.png" class="clMore" />

            <div class="clMenus" :class="menuKey == 'studentList' && 'small'">
              <p class="flex-center" @click.stop="editInfo(item)">资料编辑</p>
              <p class="flex-center" @click.stop="delClassObj = { ...item, status: true }"
                v-if="menuKey == 'teacherList'">
                管理移交
              </p>
              <p class="flex-center" @click="onDel(item.name, item.userId)">
                移除{{ menuKey == "studentList" ? "学生" : "成员" }}
              </p>
            </div>
          </div>
          <div class="clLeft">
            <img :src="item.photo" />
            <span class="clSign" v-if="item.isManager">管理员</span>
            <p class="line1">{{ item.name }}</p>
          </div>
        </li>
      </ul>
      <Empty style="margin-top: 40px;" v-if="!listObj[menuKey]?.length"/>
    </div>

    <Dialog title="移除成员" :modal="true" width="900px" :visible.sync="editObj.status">
      <div class="vfWrap flex-v flex-center">
        <h4 class="bName">
          {{ menuKey == "studentList" ? "学生" : "老师" }}姓名
        </h4>
        <Input v-model="nickName" :placeholder="`请输入${menuKey == 'studentList' ? '学生' : '老师'
          }姓名`" style="width: 320px" :maxlength="10" clearable></Input>
        <div class="dialog-footer">
          <div class="btn cancel flex-center" @click="editObj = {}">取 消</div>
          <div class="btn sure flex-center" @click="changeName">修 改</div>
        </div>
      </div>
    </Dialog>

    <Dialog :title="delClassObj.isDel ? '移除成员' : '解散班级'" :modal="true" width="900px" :visible.sync="delClassObj.status">
      <div class="vfWrap flex-v flex-center">
        <p class="diTxt" v-if="delClassObj.isDel">
          确定将“<span style="color: #ff5c5c">{{ isLot ? `这批${menuKey == "studentList" ? "学生" : "成员"}` : delClassObj.name }}</span>”<br />从“<span
            style="color: #FB7C33">{{
              classInfos.school
            }} {{ classInfos.gradeOutput }}{{ classInfos.name }}</span>”中移除！
        </p>
        <p class="diTxt" v-else>
          确定将班级管理权转让给“<span style="color: #FB7C33">{{
            delClassObj.name
          }}</span>”吗？
        </p>
        <div class="dialog-footer">
          <div class="btn cancel flex-center" @click="delClassObj = {}">
            取 消
          </div>
          <div class="btn sure flex-center" @click="onRemove" v-if="delClassObj.isDel">确 定</div>
          <div class="btn sure flex-center" @click="onTransfer" v-else>确 定</div>
        </div>
      </div>
    </Dialog>

    <Dialog title="切换班级" :modal="true" width="1200px" :visible.sync="status" class="classDialog">
      <div class="listWrap">
        <ClassList :isPage="false" @onDetail="changeClass"/>
      </div>
    </Dialog>

    <Rank ref="rankRef"/>
  </div>
</template>

<script>
import { Dialog, Input, Button, Form, FormItem } from "element-ui";
import Rank from './rank.vue';
import Empty from "business/Empty";

import ClassList from "./classList.vue";
export default {
  components: {
    Rank,
    Empty,
    ClassList,
    Dialog,
    Input,
    Form,
    FormItem,
    ElButton: Button,
  },
  data() {
    return {
      classesId: "",
      nickName: "",
      status: false,
      isLot: false, //是否批量
      classInfos: {},
      delClassObj: {},
      editObj: {},
      delList: [],
      workMenus: Object.freeze([
        {
          key: "homeWorkTotal",
          text: "已布置练习",
        },
        {
          key: "studnetReadTotal",
          text: "学生朗读次数",
        },
        {
          key: "studnetReciteTotal",
          text: "学生背诵次数",
        },
      ]),
      workObj: {},
      listObj: {
        studentList: [],
        teacherList: [],
      },
      menuKey: "studentList",
    };
  },
  methods: {
    changeClass(id) {
      this.classesId = id;
      this.menuKey = 'studentList';
      this.onCancel();
      this.status = false;
    },
    onCancel() {
      this.isLot = false;
      this.delList = [];
    },
    onDel(name, userId) {
      if (!name && !this.delList.length) return this.$toast('请选择移除成员')
      if (userId) this.delList = [userId];
      this.delClassObj = { status: true, isDel: true, name }
    },
    onSelect(id, isCancel) {
      const idx = this.delList.indexOf(id);
      idx > -1 || isCancel ? this.$delete(this.delList, idx, id) : this.$set(this.delList, this.delList.length, id);
    },
    onAllSelect(isAll) {
      this.delList = [];
      this.listObj[this.menuKey].forEach(item => {
        if(!item.isManager)this.onSelect(item.userId, !isAll)
      })
    },
    onTab(key) {
      this.onCancel();
      this.menuKey = key;
    },
    editInfo(item) {
      this.editObj = { ...item, status: true };
      this.nickName = item.name;
    },
    refreshData() {
      this.loadClassDetail();
      this.loadCount();
      this.loadSDList();
    },
    async changeName() {
      if (!this.nickName) return this.$toast("请输入姓名");
      try {
        const isStudent = this.menuKey === "studentList";
        const url = isStudent
          ? "/classes/updateStudent.json"
          : "/classes/updateTeacher.json";
        await this.$post(url, {
          name: this.nickName,
          [isStudent ? "studentId" : "teacherId"]: this.editObj.id,
        });
        this.loadSDList();
        this.$toast("姓名修改成功");
        this.editObj = {};
      } catch (error) { }
    },
    async onRemove() {
      try {
        const url = this.menuKey === "studentList"
          ? "/classes/removeStudents.json"
          : "/classes/removeTeacherClasses.json";
        const res = await this.$post(url, {
          userIds: this.delList.join(','),
          classesId: this.classesId,
        });
        this.$toast(res.data ? "移除成功" : res.message);
        this.isLot = false;
        this.loadSDList();
        this.delClassObj = {};
      } catch (error) {
        console.log(error);
      }
    },
    async onTransfer() {
      try {
        const res = await this.$post("/classes/transferClasses.json", {
          userId: this.delClassObj.userId,
          classesId: this.classesId,
        });
        this.$toast(res.data ? "转交成功" : res.message);
        if (res.data) this.classInfos.isManager = 0;
        this.loadSDList();
        this.delClassObj = {};
      } catch (error) { }
    },
    async loadClassDetail() {
      try {
        const res = await this.$post("/classes/classesInfo.json", {
          classesId: this.classesId,
        });
        const info = res.data || {};
        info.gradeTxt = (info.name?.includes('年级') ? '' : info.gradeOutput) + info.name;
        info.authStatusTxt = {
          AUTH_WAITING: "未认证",
          AUTH_YES: "已认证",
          AUTH_NO: "未通过",
        }[info.authStatus];
        info.classesAdmin =
          info.classesAdmin + (info.classesAdmin.includes("老师") ? "" : "老师");
        this.classInfos = info;
      } catch (error) {
        console.log(error);
      }
    },
    loadCount() {
      this.$post("/home/homeWorkData.json", {
        classesId: this.classesId,
      }).then((res) => {
        this.workObj = res.data || {};
      });
    },
    loadSDList() {
      this.$post("/classes/teacherAndStudentList.json", {
        classesId: this.classesId,
      }).then((res) => {
        this.listObj = res.data || {
          studentList: [],
          teacherList: [],
        };
      });
    },
  },
  watch: {
    classesId(id) {
      this.refreshData();
    },
  },
};
</script>

<style lang="less" scoped>
.classDetail.container {
  /deep/.classDialog .el-dialog__body{
    background: url('https://llss-file.langsounds.com/banner/d04fa9a890d2a0230e6a82f2eb4b13c7.png') no-repeat center top;
    background-size: 100% 100%;
    background-color:  linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(237, 255, 243, 1) 100%);
    height: 610px;
    overflow: auto;
  }
  .allDel {
    background: none;
    box-shadow: none;
    color: #666;
  }

  .cdTop {
    padding-bottom: 24px;
    border-bottom: 1px solid #cccccc;

    .back {
      align-self: flex-end;
      margin-bottom: 22px;
    }
  }

  .diTxt {
    font-size: 24px;
    padding: 20px 0;
    text-align: center;
  }

  .listWrap {

    // transform: scale(.8);
    // transform-origin: top left;
    /deep/.container {
      width: 120%;
      padding: 0;
      transform: scale(0.8);
      transform-origin: top left;
    }
  }
  .vfWrap {
    width: auto;
  }

  .rankCount {
    width: 140px;
    height: 140px;
    background: #FFFFFF;
    box-shadow: 0px 16px 18px -5px rgba(0,0,0,0.06);
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    margin-left: 80px;
    position: relative;
    cursor: pointer;
    &::before {
      content: '';
      display: block;
      position: absolute;
      left: -80px;
      top: 20px;
      width: 2px;
      height: 100px;
      background: #CCCCCC;
    }
    .iconfont {
      font-weight: normal;
      font-size: 60px;
      color: #FFAC00;
      margin-bottom: 10px;
    }
  }
}


.cdCenter {
  padding: 40px 0;

  .cList {
    padding-right: 56px;
    li {
      width: 260px;
      height: 140px;
      background: #ffffff;
      box-shadow: 0px 16px 18px -5px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      box-sizing: border-box;
      padding: 20px 40px;
      font-size: 16px;
      color: #666666;
      margin-right: 24px;

      h3 {
        font-weight: bold;
        font-weight: bold;
        font-size: 60px;
        color: #FB7C33;
        margin-bottom: 8px;
      }
    }
  }
}

.cmPage .cdBottom {
  position: relative;

  .clBtn {
    color: #666666;

    &.on {
      color: #fff;
      background-color: #FB7C33;
    }

    &.cancel {
      color: #999;
    }

    &.lotBtn {
      width: 100px;
      margin-right: 16px;
    }
  }

  .tdList {
    padding-top: 24px;
    flex-wrap: wrap;

    li {
      width: 180px;
      height: 180px;
      background: #ffffff;
      box-shadow: 0px 16px 18px -5px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      margin-right: 24px;
      margin-bottom: 24px;
      position: relative;

      // &:nth-child(8n) { 
      //   margin-right: 0;
      // }

      .clLeft {
        margin-right: 0 !important;
        width: 100%;
        position: relative;

        p {
          font-size: 24px;
          color: #333333;
          font-weight: bold;
          max-width: 86%;
          margin: 0 auto;
        }

        .clSign {
          background: #fff7e7;
          position: absolute;
          top: 60px;
          left: 60px;
        }
      }

      .clDish {
        top: 10px;
        right: 6px;
        cursor: pointer;
        padding: 0 10px 10px;
        // width: 16px;

        .clMenus {
          right: -30px;
        }
      }

      .clLot {
        font-size: 18px;

        &.xuanzhong {
          color: #FB7C33;
        }
      }
    }
  }
}

.cdScl {
  align-items: center;

  .school {
    font-size: 24px;
    color: #333333;
    font-weight: bold;
    margin-right: 24px;
  }

  .clSwitch {
    width: 100px;
    height: 40px;
    background: #FB7C33;
    border-radius: 4px;
    margin-left: 16px;
    cursor: pointer;
    font-size: 20px;
    color: #ffffff;
  }
}

.bName {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
  margin-bottom: 24px;
}

.teach {
  font-size: 20px;
  color: #333333;
}

.clTeach {
  .teach;
  font-weight: bold;
  align-items: center;
  padding-top: 8px;
  padding-bottom: 12px;

  .iconfont {
    font-weight: normal;
    color: #ccc;
    margin-left: 26px;
    margin-right: 10px;
    font-size: 18px;
  }
}

.clPerson {
  font-size: 12px;
  color: #666;
  align-items: baseline;

  span {
    font-size: 24px;
    color: #333;
    font-weight: bold;
    padding-right: 4px;
  }
}
</style>
